<p-sidebar
  [(visible)]="visible"
  (onHide)="onClose()"
  [style]="{ height: getSidebarStyles().height, 'margin-top': getSidebarStyles().marginTop }"
>
  <div class="flex column height-100 gap-05" style="padding-bottom: 40px;">
    <div class="flex column gap-05 scrollable-bar" [style.height]="getItemContainerHeight()">
      @for (menuItem of menuItems; track $index) {
      <app-menu-item
        [title]="menuItem.title"
        [icon]="menuItem.icon"
        [isActive]="menuItem.isActive"
        [unsavedContent]="handleUnsavedContent(menuItem.unsavedContent)"
        (click)="onMenuItemClick(menuItem)"
      />
      }
    </div>
    <div class="flex column">
      @if (!globalService.isApaApp()) {
      <p-divider />
      <div class="flex column gap-05 padding-05-b">
        <div class="flex width-100 flex-between align-center padding-05-r padding-05-b">
          <div>Dark Theme</div>
          <p-inputSwitch [(ngModel)]="theme" (ngModelChange)="toggleTheme($event)" />
        </div>
        <app-button
          class="flex-1"
          icon="pi pi-sign-out"
          label="Logout"
          severity="danger"
          [outlined]="globalService.theme() === 'dark'"
          (click)="signOut()"
        />
      </div>
      }
      <div class="text-xs text-secondary">Aliled Pilots Assosiation</div>
      <div class="text-xs text-secondary">Version 0.3</div>
    </div>
  </div>
</p-sidebar>
